import { Button, Space } from "antd";
import React from "react";
interface PickQuestionsFooterProps {
  pagination?: any;
  onAddHandler?: () => void;
  selectedRows?: any[];
}

const PickQuestionsFooter: React.FC<PickQuestionsFooterProps> = ({
  onAddHandler,
  selectedRows = [],
}) => {
  return (
    <div
      className="footerCloseWindowDiv"
      style={{ gap: "16px", display: "flex", justifyContent: "flex-end" }}
    >
      <Space>
        <Button
          disabled={!selectedRows.length}
          type={!selectedRows.length ? "default" : "primary"}
          onClick={onAddHandler}
        >
          Add
        </Button>
      </Space>
    </div>
  );
};

export default PickQuestionsFooter;
